import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnChanges,
    SimpleChanges,
} from '@angular/core';
import {LinkForm} from '../../../shared/link/link.form';
import {Settings} from '@common/core/config/settings.service';
import {ucFirst} from '@common/core/utils/uc-first';
import {BehaviorSubject} from 'rxjs';
import {LinkOptionsList} from '../types';
import {UtmBuilderDialogComponent} from '../utm-builder-dialog/utm-builder-dialog.component';
import {Modal} from '@common/core/ui/dialogs/modal.service';
import { CrupdateLinkFeature } from '../crupdate-link-feature';

@Component({
    selector: 'link-options-form',
    templateUrl: './link-options-form.component.html',
    styleUrls: ['./link-options-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkOptionsFormComponent implements OnChanges {
    @Input() linkOptions: LinkOptionsList;
    @Input() batch = false;
    @Input() featuresToHide: {[key in CrupdateLinkFeature]?: boolean} = {};
    @Input() resourceName = 'link';
    defaultHost$ = new BehaviorSubject<string>(null);

    alias = {
        min: this.settings.get('links.alias_min'),
        max: this.settings.get('links.alias_max'),
    };

    constructor(
        public linkForm: LinkForm,
        public settings: Settings,
        private modal: Modal
    ) {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes.linkOptions.currentValue) {
            const defaultHost = this.settings.get(
                'custom_domains.default_host'
            );
            if (defaultHost) {
                this.defaultHost$.next(
                    this.linkOptions.domains.find(d => d.host === defaultHost)
                        .host
                );
            } else {
                const baseUrl = this.settings
                    .getBaseUrl()
                    .replace(/\/$/, '')
                    .replace(/(^\w+:|^)\/\//, '');
                this.defaultHost$.next(baseUrl);
            }
        }
    }

    capitalize(str: string): string {
        return ucFirst(str);
    }

    openUtmBuilder() {
        this.modal
            .open(UtmBuilderDialogComponent, {
                utmQuery: this.linkForm.formGroup.get('utm').value,
            })
            .afterClosed()
            .subscribe(utmValue => {
                if (utmValue) {
                    this.linkForm.formGroup.patchValue({utm: utmValue});
                }
            });
    }
}
